import React from 'react';
import ModalCorreoContent from './ModalCorreoContent';

export interface ModalCorreoTemporalProps {
  isOpen: boolean;
  correoInicial?: string;
  onConfirmar: (correo: string) => Promise<void> | void;
  procesando?: boolean;
}

export const ModalCorreoTemporal: React.FC<ModalCorreoTemporalProps> = ({
  isOpen,
  correoInicial = '',
  onConfirmar,
  procesando = false
}) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.45)',
        backdropFilter: 'blur(2px)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 2000,
        padding: '20px'
      }}
    >
      <div
        style={{
          backgroundColor: '#ffffff',
          borderRadius: '16px',
          width: '100%',
          maxWidth: '520px',
          boxShadow: '0 20px 40px rgba(0, 0, 0, 0.12)',
          position: 'relative',
          boxSizing: 'border-box'
        }}
      >
        <ModalCorreoContent
          correoInicial={correoInicial}
          onConfirmar={onConfirmar}
          procesando={procesando}
        />
      </div>
    </div>
  );
};

export default ModalCorreoTemporal;

